var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1227_14581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5013 17.9972L15.0233 2.41243C13.6612 0.119256 10.3407 0.116209 8.9767 2.41243L0.499073 17.9972C-0.893396 20.3405 0.792463 23.3078 3.52167 23.3078H20.478C23.2049 23.3078 24.8938 20.3429 23.5013 17.9972ZM12 20.4953C11.2248 20.4953 10.5937 19.8642 10.5937 19.089C10.5937 18.3138 11.2248 17.6828 12 17.6828C12.7752 17.6828 13.4062 18.3138 13.4062 19.089C13.4062 19.8642 12.7752 20.4953 12 20.4953ZM13.4062 14.8703C13.4062 15.6455 12.7752 16.2765 12 16.2765C11.2248 16.2765 10.5937 15.6455 10.5937 14.8703V7.83901C10.5937 7.06379 11.2248 6.43276 12 6.43276C12.7752 6.43276 13.4062 7.06379 13.4062 7.83901V14.8703Z",
    fill: "#0D2338"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1227_14581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlue);
export default __webpack_public_path__ + "static/media/warning-blue.62b17ad3e013554613e309adc024e073.svg";
export { ForwardRef as ReactComponent };